import { STAGE_AUTO_NAVIGATION, NAVIGATE_PAGE } from './actionTypes';
import { NavUrl } from '@alme/types/response/NavUrl';

export function navigatePage(url: string, navType: string, stateLocation: string) {
return {
    type : NAVIGATE_PAGE,
    payload : {
        url,
        navType,
        stateLocation
    }
};
}

export function stageAutoNavigation(navUrl: NavUrl, stateLocation: string) {
return {
    type : STAGE_AUTO_NAVIGATION,
    payload : {
        navUrl,
        stateLocation
    }
}
}


// WEBPACK FOOTER //
// ./modules/auto-nav-url-aon/actions/actions.ts